import { FC } from 'react';

import { Box, Skeleton } from '@mui/material';

import styles from './SkeletonLoader.module.scss';

const SKELETON_PAIRS_QUANTITY = 10;

export const SkeletonLoader: FC = () => {
  return (
    <Box className={styles.wrapper}>
      {new Array(SKELETON_PAIRS_QUANTITY).fill(0).map((_, index) => (
        <Box className={styles.skeletonWrapper} key={index}>
          <Skeleton animation="wave" className={styles.skeleton} />
          <Skeleton animation="wave" className={styles.smallSkeleton} />
        </Box>
      ))}
    </Box>
  );
};
